module.exports = __webpack_public_path__ + "static/img/8.582ce8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg/8.png
// module id = 137
// module chunks = 2